

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ButtonType } from '@getaccept/lib-ui';
import type { SigningStep } from '../../types/signing-step';

@Component({
  data: () => ({
    ButtonType,
  }),
})
export default class VerifyQna extends Vue {
  @Prop() error: boolean;
  @Prop() step: SigningStep;
  @Prop() loading: boolean;
  value = '';

  errorMessage = '';

  @Watch('error')
  setError() {
    this.errorMessage = this.error
      ? this.$t('wrong-password-please-try-again-or-contact-the-sender').toString()
      : '';
  }

  get label(): string {
    return this.step && this.step.data.question
      ? this.step.data.question
      : this.$t('password').toString();
  }

  handleChange() {
    this.errorMessage = '';
  }

  close() {
    this.$emit('close');
  }

  verify() {
    this.$emit('verify', this.value);
  }
}
